'use client'

import { useId, useState } from 'react'
import './Accordion.css'

/**
 * Disclosure list. The first item is open by default, matching the design.
 * Each header is a real button wired to its panel with aria-expanded /
 * aria-controls so screen readers announce the open state.
 */
export function Accordion({ items = [], style }) {
  const [open, setOpen] = useState(0)
  const baseId = useId()

  return (
    <div className="u-acc" style={style}>
      {items.map((it, i) => {
        const isOpen = open === i
        const headId = `${baseId}-head-${i}`
        const panelId = `${baseId}-panel-${i}`

        return (
          <div
            key={it.q ?? i}
            className={'u-acc-item' + (isOpen ? ' u-acc-item--open' : '')}
          >
            <h3 style={{ margin: 0, font: 'inherit', letterSpacing: 'normal' }}>
              <button
                type="button"
                id={headId}
                className="u-acc-head"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpen(isOpen ? -1 : i)}
              >
                <span>{it.q}</span>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </button>
            </h3>
            <div
              id={panelId}
              role="region"
              aria-labelledby={headId}
              className="u-acc-body"
              hidden={!isOpen}
            >
              {it.a}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Accordion
